import { getRecurly } from '@mm/hooks';
import { useEffect, useState } from 'react';
import { get } from 'lodash';

type RecurlyFormFieldState = {
  empty: string;
  focus: boolean;
  valid: boolean;
};

type RecurlyCreditCardObject = {
  brand: string;
  cvv: RecurlyFormFieldState;
  expiry: RecurlyFormFieldState;
  firstSix: string;
  lastFour: string;
  number: RecurlyFormFieldState;
} & RecurlyFormFieldState;

type RecurlyCreditCardChangeObject = {
  fields: {
    card: RecurlyCreditCardObject;
  };
};

// For security Recurly uses an iFrame for Credit Card form fields. This hook gets that state from Recurly's
// event api instead of relying on Formik and Yup.
export const useCreditCardFormState = () => {
  const [creditCardFormState, setCreditCardFormState] = useState({
    error: '',
    touched: false,
    focused: true,
  });

  const onCreditCardFormChange = (changes: RecurlyCreditCardChangeObject) => {
    const card: RecurlyCreditCardObject = get(changes, 'fields.card');

    if (card) {
      // Recurly does not give details so just say generic error
      const error = card.valid ? '' : 'Card Error';

      setCreditCardFormState({
        error,
        focused: card.focus,
        touched: !card.empty,
      });
    }
  };

  useEffect(() => {
    const addChangeListener = async () => {
      const Recurly = await getRecurly();
      Recurly.on('change', onCreditCardFormChange);
    };

    const removeChangeListener = async () => {
      const Recurly = await getRecurly();
      Recurly.off('change', onCreditCardFormChange);
    };

    addChangeListener();

    return () => {
      removeChangeListener();
    };
  }, []);

  return creditCardFormState;
};
